import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import uiInfo from "../../../ui-info";
import PaginaToolbar from "../../../components/PaginaToolbar";
import { criarCpbsDs, criarQualificacaoSociosDs } from "../../../DataSources";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import notify from "devextreme/ui/notify";
import apiAxios from "../../../api-axios";
import UserInfo from "../../../UserInfo";
import Toolbar, { Item } from "devextreme-react/toolbar";
import ShowError from "../../../AppServices";

export default class SociosBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.onDeletandoRow = this.onDeletandoRow.bind(this);
    this.cpbsDs = criarCpbsDs();
    this.state = { contribuinteNome: "", sociosDs: [] };
  }

  onDeletandoRow(e) {
    apiAxios
      .delete(`/cpbs/remover_socios/${e.data.cpbsId}/${e.data.id}`)
      .catch((error) => {
        e.cancel = true;
        ShowError(error);
      });
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push({
      pathname: `/cpbs_socios/${this.state.cpbsId}/editar/${e.data.id}`,
      dadosCpbs: {
        inscricao: this.state.inscricao,
        contribuinteNome: this.state.contribuinteNome,
      },
    });
  }

  componentDidMount() {
    const cpbsId = this.props.match.params.inscricao;

    if (cpbsId) {
      this.cpbsDs
        .load({
          filter: [["id", "=", cpbsId]],
        })
        .then((data) => {
          if (data === undefined) {
            notify("CPBS não encontrado.", "error");
            this.props.history.push("/cpbs");
          }

          apiAxios
            .get(
              `/cpbs/prefeitura/${UserInfo.getPrefeitura()}/${cpbsId}/socios`
            )
            .then((dataSocios) => {
              if (data[0] !== undefined) {
                this.setState({
                  sociosDs: dataSocios.data.data,
                  cpbsId: data[0].id,
                  inscricao: data[0].inscricao,
                  contribuinteNome: data[0].contribuinte.nome,
                });
              }
            });
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.push("/cpbs");
        });
    } else {
      console.log(this.props);
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Toolbar>
            <Item
              location="left"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Voltar",
                icon: "arrowleft",
                onClick: (e) => {
                  console.log("evento socios box", e);
                  this.props.history.push("/cpbs/editar/" + this.state.cpbsId);
                },
              }}
            />
          </Toolbar>
          <Form formData={this.state} colCount={3}>
            <GroupItem caption="DADOS CPBS" colSpan={3} colCount={5}>
              <SimpleItem
                dataField={"inscricao"}
                colSpan={1}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Inscrição" />
              </SimpleItem>
              <SimpleItem
                dataField={"contribuinteNome"}
                colSpan={4}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Nome" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <br />
          <PaginaToolbar
            titulo="CPBS Sócios"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.sociosDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
              onRowRemoving={this.onDeletandoRow}
            >
              <FilterRow visible={true} />
              <Editing
                allowDeleting={true}
                allowUpdating={true}
                useIcons={true}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"qualificacaoId"} caption={"Qualificação"}>
                <Lookup
                  dataSource={criarQualificacaoSociosDs()}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Column dataField={"contribuinte.nome"} caption={"Nome"} />
              <Column
                dataField={"contribuinte.documento"}
                caption={"Documento"}
              />
              <Column
                dataField={"responsabilidade"}
                caption={"Responsabilidade"}
              >
                <Lookup
                  dataSource={[
                    { id: 0, descricao: "Nenhuma" },
                    { id: 1, descricao: "Responsável" },
                    { id: 2, descricao: "Co-Responsável" },
                  ]}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Column
                dataField={"principal"}
                caption={"Principal"}
                width={100}
              />
              <Column dataField={"inicio"} dataType="date" caption={"Início"} />
              <Column dataField={"fim"} dataType="date" caption={"Fim"} />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    this.props.history.push({
      pathname: `/cpbs_socios/${this.state.cpbsId}/novo`,
      dadosCpbs: {
        inscricao: this.state.inscricao,
        contribuinteNome: this.state.contribuinteNome,
      },
    });
  }
}
